import { render, staticRenderFns } from "./TransferCashback.vue?vue&type=template&id=39c1600a"
import script from "./TransferCashback.vue?vue&type=script&lang=js"
export * from "./TransferCashback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports